import "../../../App.css";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import BackOnly from "../../../components/BackOnly";
import ContactPopup from "../../../components/ContactPopup";
import React, { useState, useEffect } from "react";

import { useNavigate } from "react-router-dom";   // ⭐ REQUIRED

import AffiliateBooking from "../../../components/affiliate/AffiliateBooking";
import AffiliateExpedia from "../../../components/affiliate/AffiliateExpedia";
import AffiliateTrip from "../../../components/affiliate/AffiliateTrip";

// ⭐ STRICT COMMAND: Canyon City ALWAYS goes back to Colorado map
export const backRoute = "/map/colorado";

export default function CanyonCity() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  // ⭐ Send strict back command to BackOnly (NO LOOPS)
  useEffect(() => {
    if (!window.__canyonCityBackRouteSet) {
      window.__canyonCityBackRouteSet = true;
      navigate(".", { replace: true, state: { backRoute } });
    }
  }, [navigate]);

  return (
    <>
      <Header />

      <div className="visited-back-wrapper">
        <BackOnly />
      </div>


      <div className="page-container" style={{ padding: "12px" }}>
        <h1>Cañon City, Colorado</h1>

        <section className="travel-review">
          {/* LEFT COLUMN — TEXT */}
          <div className="travel-text">
            <h2>🏞️ Discover Cañon City, Colorado</h2>

            <p>
              Cañon City, located about 50 miles southwest of Colorado Springs and nestled between the small towns of Florence and Penrose,
               is a charming gateway to the Royal Gorge region. Set in the Arkansas River Valley, this small but adventure‑packed town blends canyon landscapes,
                mild weather, and a relaxed Western feel. Visitors come for the white‑water rafting, ridge‑top drives, historic Main Street,
                 and the dramatic Royal Gorge itself—but many stay for the warm community vibe and the slower, sun‑soaked pace that defines life here.
            </p>

            <h3>🚗 Getting There</h3>

            <p>
              Cañon City is easy to reach whether you’re flying into Denver International Airport (DEN) or Colorado Springs Airport (COS). 
              From Denver, the distance is about 120 miles, and the drive typically takes around 2 hours and 30 minutes depending on traffic,
               following I‑25 South, CO‑115 South, and US‑50 West. From Colorado Springs, the trip is much shorter—about 45 to 50 miles and
                roughly a 60‑minute drive—using CO‑115 South and US‑50 West.
            </p>

            {/* 🌟 MY PERSONAL OBSERVATION */}
            <h3>🌟 My Personal Observation</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Royal Gorge Bridge and Park:</strong> One of my favorite places in Cañon City is the Royal Gorge.
                  This iconic bridge stretches across the canyon with a view that’s truly breathtaking. You can cross by foot
                  or take the gondola for a smooth ride above the gorge. For thrill-seekers (not included in general admission),
                  there’s a zipline that flies across the canyon and a catapult that launches you into the air — don’t worry,
                  you’re securely tied to a cable. The park also offers food stands and snacks, making it easy to spend a few
                  hours soaking it all in.
                  <br />
                  <strong>Royal Gorge Map Pin</strong><br />
                  <a
                    href="https://www.google.com/maps?q=38.462083,-105.324611"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Map
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Royal Gorge Route Railroad:</strong> As stunning as the view from the Royal Gorge Bridge, this train
                  ride is a must-do if you're exploring around Cañon City. The route takes you deep into the canyon, offering a
                  unique perspective of the bridge from below — it’s a whole different kind of awe. You can enjoy food and drinks
                  onboard while soaking in the scenery, making the ride both relaxing and unforgettable.
                  <br />
                  <strong>Royal Gorge Route Railroad:</strong> Scenic train ride through the gorge.<br />
                  <a
                    href="https://www.google.com/maps?q=38.438059772678955,-105.24066507706453"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Map
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Skyline Drive:</strong> This is a one-way road with a unique view from the top of the mountain.
                  Along the ridge, you’ll find a few spots to pull over and take pictures — the kind that make you pause and
                  appreciate how small everything looks below. The drive eventually winds down into the back part of town,
                  making it a short but unforgettable ride.
                  <br />
                  <strong>Skyline Drive:</strong><br />
                  <a
                    href="https://www.google.com/maps?q=38.47266224175532,-105.25731237990634"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    📍 Map
                  </a>
                </div>
              </li>
            </ul>

            {/* 🥾 OTHER HIDDEN GEMS */}
            <h3>🥾 Other Hidden Gems</h3>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Helicopter Tours</strong>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Museum of Colorado Prisons</strong>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Temple Canyon Park</strong>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Red Canyon Park</strong>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Tunnel Drive Trail</strong>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Garden Park Fossil Area</strong>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Phantom Canyon Road</strong>
                </div>
              </li>
            </ul>

            {/* 🛏️ PLACES TO STAY */}
            <h3>🛏️ Places to Stay in Cañon City</h3>

            <p>
              Whether you're chasing canyon views, rafting thrills, or a quiet night under the stars,
              Cañon City offers a range of stays that reflect its rugged beauty and laid-back vibe.
            </p>

            <ul>
              <li>
                <div className="place-block">
                  <strong>Parkview Inn Motel:</strong> A charming, old-school motel with clean rooms and a prime location
                  across from the Royal Gorge Railroad.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Royal Gorge Cabins:</strong> Upscale mountain cabins with sleek design, private fire pits, and
                  epic views.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Best Western Cañon City:</strong> Reliable comfort with spacious rooms and a pool.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Holiday Inn Express & Suites:</strong> Modern amenities, friendly staff, and a custom pool.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Mountain View RV Resort:</strong> Scenic RV sites with mountain backdrops.
                </div>
              </li>

              <li>
                <div className="place-block">
                  <strong>Royal Gorge KOA:</strong> Cabins, tent sites, RV hookups, and family-friendly amenities.
                </div>
              </li>
            </ul>

           <h3>If you are looking for a place to stay, you can check prices, date and time here.</h3>
                       <div className="affiliate-block">
                         <AffiliateExpedia />
                         <AffiliateBooking />
                         <AffiliateTrip />
                       </div>
            {/* 🎥 VIDEOS */}
            <h3>🎥 My Travel Videos</h3>

            <p>
              Here are some videos I took from the Royal Gorge Bridge, the Royal Gorge Railroad, and Skyline Drive:
            </p>

            <ul>
              <li>
                <div className="place-block">
                  <a
                    href="https://youtu.be/RvYml6Nw3tg"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Royal Gorge Bridge
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <a
                    href="https://youtu.be/aYSlUeQTeZc"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Royal Gorge Railroad
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <a
                    href="https://youtu.be/RRIphlOPKgs"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Royal Gorge Railroad 360 view
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <a
                    href="https://youtu.be/Ek1_UCAqzbg"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Skyline Drive Aerial View
                  </a>
                </div>
              </li>

              <li>
                <div className="place-block">
                  <a
                    href="https://youtu.be/Y5_zbYnIKiw"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Skyline Drive
                  </a>
                </div>
              </li>
            </ul>
          </div>

         {/* RIGHT COLUMN — IMAGES */}
<div className="travel-image-column">
  <a
    href="https://youtu.be/RvYml6Nw3tg"
    target="_blank"
    rel="noopener noreferrer"
    className="youtube-image-card"
  >
    <img
      src="/images/usa/colorado/canyoncity/royalgorge.jpg"
      alt="Royal Gorge Bridge Video"
    />
  </a>

  <a
    href="https://youtu.be/aYSlUeQTeZc"
    target="_blank"
    rel="noopener noreferrer"
    className="youtube-image-card"
  >
    <img
      src="/images/usa/colorado/canyoncity/royalgorgebridge.jpg"
      alt="Royal Gorge Train Video"
    />
  </a>

            <a
              href="https://youtu.be/Y5_zbYnIKiw"
              target="_blank"
              rel="noreferrer"
              className="youtube-image-card"
            >
              <img
                src="/images/usa/colorado/canyoncity/skylinedrive.jpg"
                alt="Skyline Drive Video"
              />
            </a>

             <img
              src="/images/usa/colorado/canyoncity/bridge.jpg"
              alt="Bridge"
              loading="lazy"
            />

            <img
              src="/images/usa/colorado/canyoncity/royalgorgeentrance.jpg"
              alt="Royal Gorge Entrance"
              loading="lazy"
            />

            <img
              src="/images/usa/colorado/canyoncity/zipline.jpg"
              alt="Zipline at Royal Gorge"
              loading="lazy"
            />

            <img
              src="/images/usa/colorado/canyoncity/train.jpg"
              alt="Royal Gorge Train"
              loading="lazy"
            />
          </div>
        </section>
      </div>

      {/* EMAIL BUTTON */}
      <div className="email-wrapper">
        <button className="email-link" onClick={() => setOpen(true)}>
          contact@thefindingspot.com
        </button>
      </div>

      {/* POPUP */}
      <ContactPopup isOpen={open} onClose={() => setOpen(false)} />

      <Footer />
    </>
  );
}
